import { ref, watch } from 'vue'
import client from '@/composables/homebaseClient'

export default function useHomebaseContainers(initialParams = {}) {
    const containers = ref([])
    const containerDetail = ref(null)
    const loading = ref(false)
    const detailLoading = ref(false)
    const error = ref(null)

    const params = ref({
        unassigned: '',
        limit: 1000,
        sortBy: 'createdAt',
        sortDir: 'desc',
        ...initialParams
    })

    const toQuery = () => {
        const q = new URLSearchParams()
        if (params.value.unassigned !== '') q.set('unassigned', params.value.unassigned)
        if (params.value.limit) q.set('limit', String(params.value.limit))
        if (params.value.sortBy) q.set('sortBy', params.value.sortBy)
        if (params.value.sortDir) q.set('sortDir', params.value.sortDir)
        return q.toString() ? `?${q.toString()}` : ''
    }

    const fetchContainers = async () => {
        loading.value = true
        error.value = null
        try {
            const res = await client.get(`/containers${toQuery()}`)
            containers.value = Array.isArray(res.data) ? res.data : []
        } catch (err) {
            error.value = err.detail || 'Failed to load containers'
        } finally {
            loading.value = false
        }
    }

    const fetchContainerDetail = async (containerId) => {
        detailLoading.value = true
        try {
            const res = await client.get(`/containers/${containerId}`)
            containerDetail.value = res.data
            return res.data
        } catch (err) {
            error.value = err.detail || 'Failed to load container details'
            throw err
        } finally {
            detailLoading.value = false
        }
    }

    const createContainer = async (containerData) => {
        try {
            const res = await client.post('/containers', containerData)
            await fetchContainers() // refresh list
            return res.data
        } catch (err) {
            throw new Error(err.detail || 'Failed to create container')
        }
    }

    const fetchContainerHistory = async (containerId) => {
        try {
            const res = await client.get(`/containers/${containerId}/history`)
            return res.data
        } catch (err) {
            error.value = err.detail || 'Failed to load container history'
            throw err
        }
    }

    // Auto-fetch when params change
    watch(params, fetchContainers, { deep: true })

    return {
        containers,
        containerDetail,
        loading,
        detailLoading,
        error,
        params,
        fetchContainers,
        fetchContainerDetail,
        createContainer,
        fetchContainerHistory
    }
}



